<template>
    <td-dialog :title="this.title" :visible.sync="dialogVisible" :width="'750px'" :before-close="cancel" :close-on-click-modal="false" :close-on-press-escape="false" top="100px">
        <el-form :model="networkForm" ref="networkForm" :rules="rules" class="demo-form-inline" label-width="120px" @submit.native.prevent>
            <el-form-item :label="$t('pgCommon.AREA_NETWORK')" prop="sId">
                <td-select v-model="networkForm.sId" :options="networkSettingList" :disabled="disabledSelectNetworkName" keys="sId" text="sName" maxlength="50"></td-select>
            </el-form-item>
        </el-form>
        <el-row>
            <p style="color:red;margin-left: 20px;">
                {{ $t('pgCommon.AREA_NETWORK_EXPLAIN') }}
            </p>
        </el-row>
        <!-- ---------------折叠面板---------------------- -->
        <el-collapse v-model="activeNames" @change="handleChange">
            <!-- 白名单折叠面板 -->
            <el-collapse-item type="primary" :title="$t('pgCommon.NETWORKAREA_WHITElIST')" name="1">
                <!-- <el-row> -->
                <el-container>
                    <!-- ---------------白名单树状图---------------------- -->
                    <el-col :span="10">
                        <div class="grid-content bg-purple">
                            <td-tree
                                height="418"
                                ref="WhiteTreeRef"
                                @queryData="queryMiddlewareTreeForNoPlugin"
                                :treeList="middlewareTreeList"
                                :lazyloading="false"
                                :defaultProps="defaultProps"
                                :inputShow="true"
                                :nodeKey="nodeKey"
                                :expandAll="false"
                                :showBox="true"
                                :checkStrictly="true"
                                @check="whiteTreeNodeClick"
                                :isDistributed="false"
                                :calInternal="false"
                                :imgloading="true"
                                @refresh="refresh"
                            >
                            </td-tree>
                        </div>
                    </el-col>
                    <!-- ------------------白名单传输按钮----------------------- -->
                    <el-col :span="2" class="buttonClass">
                        <td-button @click="whiteAddToRight" type="primary" class="buttonright" icon="el-icon-d-arrow-right" style="min-width:40px" circle></td-button>
                        <td-button @click="whiteAddToLeft" type="primary" class="buttonleft" icon="el-icon-d-arrow-left" style="min-width:40px" circle></td-button>
                    </el-col>
                    <!-- ---------------------白名单表格-------------------------- -->
                    <el-col :span="10">
                        <td-input maxlength="50" v-model="whiteSearchName" :hasBtn="true" :placeholder="$t('pgCommon.NETWORKAREA_TIPS')" class="search"></td-input>
                        <td-table ref="whiteTableRef" :dataSource="whiteTable" :columns="columns" :hasIndex="false" :hasPage="false" height="400"></td-table
                    ></el-col>
                </el-container>
                <!-- </el-row> -->
            </el-collapse-item>
            <!-- 黑名单折叠面板 -->
            <el-collapse-item :title="$t('pgCommon.NETWORKAREA_BLACKlIST')" name="2">
                <!-- <el-row> -->
                <el-container>
                    <!-- ---------------黑名单树状图---------------------- -->
                    <el-col :span="10">
                        <div class="grid-content bg-purple">
                            <td-tree
                                height="418"
                                ref="BlackTreeRef"
                                @queryData="queryMiddlewareTreeForNoPlugin"
                                :treeList="middlewareTreeList"
                                :lazyloading="false"
                                :defaultProps="defaultProps"
                                :inputShow="true"
                                :nodeKey="nodeKey"
                                :expandAll="false"
                                :showBox="true"
                                :checkStrictly="true"
                                @check="blackTreeNodeClick"
                                :isDistributed="false"
                                :calInternal="false"
                                :imgloading="true"
                                @refresh="refresh"
                            >
                            </td-tree>
                        </div>
                    </el-col>
                    <!-- ------------------黑名单传输按钮----------------------- -->
                    <el-col :span="2" class="buttonClass">
                        <td-button @click="blackAddToRight" type="primary" class="buttonright" icon="el-icon-d-arrow-right" style="min-width:40px" circle></td-button>
                        <td-button @click="blackAddToLeft" type="primary" class="buttonleft" icon="el-icon-d-arrow-left" style="min-width:40px" circle></td-button>
                    </el-col>
                    <!-- ---------------------黑名单表格-------------------------- -->
                    <el-col :span="10">
                        <td-input maxlength="50" v-model="blackSearchName" :hasBtn="true" :placeholder="$t('pgCommon.NETWORKAREA_TIPS')" class="search"></td-input>
                        <td-table ref="blackTableRef" :dataSource="blackTable" :columns="columns" :hasIndex="false" :hasPage="false" height="400"></td-table
                    ></el-col>
                </el-container>
                <!-- </el-row> -->
            </el-collapse-item>
        </el-collapse>
        <!-- foot按钮 -->
        <span slot="footer">
            <td-button type="primary" :loading="saveLoading" @click="submitForm(networkForm)">{{ $t('common.SAVE') }}</td-button>
            <td-button @click="cancel">{{ $t('common.CANCAL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import api from './api.js';
export default {
    props: {
        title: {
            type: String,
            defalut: ''
        },
        dialogVisible: {
            type: Boolean,
            defalut: function() {
                return false;
            }
        },
        editData: {
            type: Object,
            defalut: null
        },
        isAdd: {
            type: Boolean,
            defalut: function() {
                return false;
            }
        },
        disabledSelectNetworkName: {
            type: Boolean,
            defalut: function() {
                return false;
            }
        }
    },
    created() {
        this.initSelect();
        this.queryMiddlewareTreeForNoPlugin();
        this.showNetworkAreaWhiteBlackList();
    },
    data() {
        return {
            queryCache: false,
            whiteSearchName: '',
            blackSearchName: '',
            // 表单信息
            networkForm: {
                sId: ''
            },
            activeNames: '1',
            saveLoading: false,
            nodeKey: 'id',
            middlewareTreeList: [],
            whiteTableList: [],
            whiteTable: [],
            blackTable: [],
            blackTableList: [],
            whiteList: [], //白名单id列表
            blackList: [], //黑名单id列表
            networkSettingList: [],
            defaultProps: {
                children: 'children',
                label: 'name',
                id: 'id',
                imgName: 'sIcon',
                parentId: 'parentId'
            },
            columns: [
                {
                    prop: 'name',
                    label: this.$t('pgCommon.ALL_CHOOSE'),
                    tableWidth: '255',
                    align: 'left',
                    showOverflowTooltip: true
                }
            ],
            //对表单进行数据验证
            rules: {
                sId: [{ required: true, message: this.$t('pgCommon.ERROR_SID_NULL'), trigger: 'change' }]
            }
        };
    },
    watch: {
        whiteSearchName: function(newVal, oldVal) {
            if (this.$util.isEmpty(newVal)) {
                this.whiteTable = this.$util.clone(this.whiteTableList);
            } else {
                let temp = [];
                var regx = new RegExp(newVal);
                for (let b = 0; b < this.whiteTable.length; b++) {
                    if (this.whiteTable[b].name.match(regx)) {
                        temp.push(this.whiteTable[b]);
                    }
                }
                this.whiteTable = temp;
                // console.log(newVal + '--' + oldVal);
            }
        },
        blackSearchName: function(newVal, oldVal) {
            if (this.$util.isEmpty(newVal)) {
                this.blackTable = this.$util.clone(this.blackTableList);
            } else {
                let temp = [];
                var regx = new RegExp(newVal);
                for (let b = 0; b < this.blackTable.length; b++) {
                    if (this.blackTable[b].name.match(regx)) {
                        temp.push(this.blackTable[b]);
                    }
                }
                this.blackTable = temp;
                // console.log(newVal + '--' + oldVal);
            }
        }
    },
    methods: {
        refresh() {
            this.queryMiddlewareTreeForNoPlugin();
        },

        /**白名单向右传输按钮触发 */
        whiteAddToRight() {
            this.whiteSearchName = '';
            let leftCheckedData = this.$refs.WhiteTreeRef.getCheckedNodes();
            if (leftCheckedData.length == 0) {
                let message = this.$t('pgCommon.AREA_NETWORK_MESSAGE');
                this.$message({ showClose: true, message: message, type: 'warning' });
                return;
            }
            const key = 'sId';
            try {
                let messageFlag = true;
                leftCheckedData.forEach(element => {
                    let repeatFlag = false;
                    for (let i = 0; i < this.blackTableList.length; i++) {
                        if (this.blackTableList[i][key] == element[key]) {
                            let message = this.$t('pgCommon.AREA_NETWORK_REPEAT');
                            if (messageFlag) {
                                this.$message({ showClose: true, message: message, type: 'warning' });
                                messageFlag = false;
                            }
                            // throw message;
                            repeatFlag = true;
                            break;
                        }
                    }
                    if (repeatFlag) {
                        return;
                    }
                    let flag = false;
                    for (let i = 0; i < this.whiteTableList.length; i++) {
                        if (this.whiteTableList[i][key] == element[key]) {
                            flag = true;
                            break;
                        }
                    }
                    if (!flag) {
                        let elementTemp = this.$util.clone(element);
                        elementTemp.children = [];
                        this.whiteTable.push(elementTemp);
                        this.whiteList.push(elementTemp.sId);
                        this.whiteTableList.push(elementTemp);
                    }
                });
            } catch (err) {
                //跳出循环
                console.debug(err);
            }

            //清空左侧的选择
            this.$refs.WhiteTreeRef.clearTreeData();
        },
        /**白名单向左传输按钮触发 */
        whiteAddToLeft() {
            let tableRows = this.$refs.whiteTableRef.getSelectAllRows();
            tableRows.forEach(data => {
                this.whiteTable.forEach((item, index) => {
                    if (data.sId == item.sId) {
                        this.whiteTable.splice(index, 1);
                    }
                });
                this.whiteTableList.forEach((item, index) => {
                    if (data.sId == item.sId) {
                        this.whiteTableList.splice(index, 1);
                    }
                });
            });
            if (this.whiteTable) {
                this.whiteList = [];
                this.whiteTable.forEach(whiteItem => {
                    this.whiteList.push(whiteItem.sId);
                });
            }
        },
        /**黑名单向右传输按钮触发 */
        blackAddToRight() {
            this.blackSearchName = '';
            let leftCheckedData = this.$refs.BlackTreeRef.getCheckedNodes();
            if (leftCheckedData.length == 0) {
                let message = this.$t('pgCommon.AREA_NETWORK_MESSAGE');
                this.$message({ showClose: true, message: message, type: 'warning' });
                return;
            }
            const key = 'sId';
            let messageFlag = true;
            try {
                leftCheckedData.forEach(element => {
                    let repeatFlag = false;
                    for (let i = 0; i < this.whiteTableList.length; i++) {
                        if (this.whiteTableList[i][key] == element[key]) {
                            let message = this.$t('pgCommon.AREA_NETWORK_REPEAT');
                            if (messageFlag){
                                this.$message({ showClose: true, message: message, type: 'warning'});
                                messageFlag = false;
                            }
                            // throw message;
                            repeatFlag = true;
                            break;
                        }
                    }
                    if (repeatFlag) {
                        return;
                    }
                    let flag = false;
                    for (let i = 0; i < this.blackTableList.length; i++) {
                        if (this.blackTableList[i][key] == element[key]) {
                            flag = true;
                            break;
                        }
                    }
                    if (!flag) {
                        let elementTemp = this.$util.clone(element);
                        elementTemp.children = [];
                        this.blackTable.push(elementTemp);
                        this.blackList.push(elementTemp.sId);
                        this.blackTableList.push(elementTemp);
                    }
                });
            } catch (err) {
                //跳出循环
                console.debug(err);
            }

            //清空左侧的选择
            this.$refs.BlackTreeRef.clearTreeData();
        },
        /**黑名单向左传输按钮触发 */
        blackAddToLeft() {
            let tableRows = this.$refs.blackTableRef.getSelectAllRows();
            tableRows.forEach(data => {
                this.blackTable.forEach((item, index) => {
                    if (data.sId == item.sId) {
                        this.blackTable.splice(index, 1);
                    }
                });
                this.blackTableList.forEach((item, index) => {
                    if (data.sId == item.sId) {
                        this.blackTableList.splice(index, 1);
                    }
                });
            });
            if (this.blackTable) {
                this.blackList = [];
                this.blackTable.forEach(whiteItem => {
                    this.blackList.push(whiteItem.sId);
                });
            }
        },
        /**白名单树节点选中状态改变时触发 */
        whiteTreeNodeClick(data) {
            let isCheck = this.$refs.WhiteTreeRef.getNode(data).checked;
            let node = this.$refs.WhiteTreeRef.getNode(data);
            this.childNodesChange(node, isCheck);
        },
        /**黑名单树节点选中状态改变时触发 */
        blackTreeNodeClick(data) {
            let isCheck = this.$refs.BlackTreeRef.getNode(data).checked;
            let node = this.$refs.BlackTreeRef.getNode(data);
            this.childNodesChange(node, isCheck);
        },
        /**树型子节点的选中状态跟随父节点变化 */
        childNodesChange(node, isCheck) {
            let len = node.childNodes.length;
            for (let i = 0; i < len; i++) {
                node.childNodes[i].checked = isCheck;
                this.childNodesChange(node.childNodes[i], isCheck);
            }
        },
        /**白名单 */
        searchListByName() {},
        /**关闭按钮触发的方法 */
        cancel() {
            this.$emit('dialogClose');
        },
        /**保存成功后调用父页面的方法 */
        refreshData() {
            this.$emit('refreshData');
        },
        /**保存按钮触发的方法 */
        submitForm() {
            this.$refs.networkForm.validate(valid => {
                if (valid) {
                    if (this.isAdd) {
                        this.saveNetworkAreaSetting(); //执行添加方法
                    } else {
                        this.updateNetworkAreaWhiteBlackList(); //执行编辑方法
                    }
                }
            });
        },
        /**添加弹框保存按钮触发的方法 */
        saveNetworkAreaSetting() {
            this.saveLoading = true;
            //白名单数据和黑名单数据不能有重复
            for (let i = 0; i < this.whiteList.length; i++) {
                for (let j = 0; j < this.blackList.length; j++) {
                    if (this.whiteList[i] == this.blackList[j]) {
                        this.$message({ showClose: true, message: this.$t('pgCommon.WHITE_BLACK_HAS_REAPEAT_DATA'), type: 'warning' });
                        this.saveLoading = false;
                        return;
                    }
                }
            }
            let content = {
                sNetworkSettingId: this.networkForm.sId,
                //sNetworkSettingId: '8966196bfa2a4e8e9ef3855d2b1361fc',
                whiteList: this.whiteList,
                blackList: this.blackList
            };
            api.saveNetworkAreaSetting(content, response => {
                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                    this.$log.error('/networkAreaSetting/saveNetworkAreaSetting', response);
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/networkAreaSetting/saveNetworkAreaSetting', response);
                    return;
                }
                this.saveLoading = false;
                let message = this.$t('common.ADD_SUCCESS');
                this.$message({ showClose: true, message: message, type: 'success' });
                this.$emit('dialogClose');
            });
        },
        /**编辑弹框保存按钮触发的方法 */
        updateNetworkAreaWhiteBlackList() {
            this.saveLoading = true;
            //白名单数据和黑名单数据不能有重复
            for (let i = 0; i < this.whiteList.length; i++) {
                for (let j = 0; j < this.blackList.length; j++) {
                    if (this.whiteList[i] == this.blackList[j]) {
                        this.$message({ showClose: true, message: this.$t('pgCommon.WHITE_BLACK_HAS_REAPEAT_DATA'), type: 'warning' });
                        this.saveLoading = false;
                        return;
                    }
                }
            }
            let content = {
                sNetworkAreaSettingId: this.networkForm.sId,
                whiteList: this.whiteList,
                blackList: this.blackList
            };
            api.updateNetworkAreaWhiteBlackList(content, response => {
                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                    this.$log.error('/networkAreaSetting/updateNetworkAreaWhiteBlackList', response);
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/networkAreaSetting/updateNetworkAreaWhiteBlackList', response);
                    return;
                }
                this.saveLoading = false;
                let message = this.$t('common.MODIFY_SUCCESS');
                this.$message({ showClose: true, message: message, type: 'success' });
                this.$emit('dialogClose');
            });
        },
        /**网络下拉框 */
        initSelect() {
            if (this.isAdd) {
                api.listFilterNetworkSettings(null, response => {
                    if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                        this.$log.error('/networkAreaSetting/listFilterNetworkSettings', response);
                        return;
                    }
                    if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('/networkAreaSetting/listFilterNetworkSettings', response);
                        return;
                    }
                    this.networkSettingList = response.data.content;
                });
            } else {
                this.networkForm.sId = this.editData.sId;
                this.networkSettingList.push({
                    sId: this.editData.sId,
                    sName: this.editData.sName
                });
            }
        },
        /**配置页面获取树形中间件 */
        queryMiddlewareTreeForNoPlugin: function() {
            api.queryMiddlewareTreeForNoPlugin('', response => {
                if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                    this.$log.error('/device/middleware/queryMiddlewareTreeForNoPlugin', response);
                    return;
                }
                if (!response.data || !response.data.statusCode) {
                    return;
                }
                if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                    this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                    this.$log.error('/device/middleware/queryMiddlewareTreeForNoPlugin', response.data.statusMessage);
                    return;
                }
                // 初始化树形数据
                this.middlewareTreeList = response.data.content;
            });
        },
        /**查询网络配置黑白名单对象 */
        showNetworkAreaWhiteBlackList() {
            if (!this.isAdd) {
                let params = {
                    sNetworkAreaSettingId: this.networkForm.sId
                };
                api.showNetworkAreaWhiteBlackList(params, response => {
                    if (response.status !== window.vue.$common.login.RESPONSE_STATUS) {
                        this.$log.error('/networkSetting/showNetworkAreaWhiteBlackList', response);
                        return;
                    }
                    if (response.data.statusCode !== this.$common.requestCode.SUCCESS_INFO_CODE) {
                        this.$message({ showClose: true, message: response.data.statusMessage, type: 'error' });
                        this.$log.error('/networkSetting/showNetworkAreaWhiteBlackList', response);
                        return;
                    }
                    let whiteObjList = [];
                    let blackObjList = [];
                    if (response.data.content.whiteList.length > 0) {
                        response.data.content.whiteList.forEach(item => {
                            whiteObjList.push({
                                sId: item.sId,
                                name: item.sName
                            });
                            this.whiteList.push(item.sId);
                        });
                    }
                    if (response.data.content.blackList.length > 0) {
                        response.data.content.blackList.forEach(item => {
                            blackObjList.push({
                                sId: item.sId,
                                name: item.sName
                            });
                            this.blackList.push(item.sId);
                        });
                    }
                    this.whiteTable = whiteObjList;
                    this.whiteTableList = window.vue.$util.clone(this.whiteTable);
                    this.blackTable = blackObjList;
                    this.blackTableList = window.vue.$util.clone(this.blackTable);
                });
            }
        }
    }
};
</script>
<style scoped>
/deep/.el-table .cell {
    text-align: left !important;
}
/deep/.el-transfer-panel {
    width: 274px;
}
/deep/.el-transfer {
    font-size: 14px;
    padding-left: 24px;
}
/deep/.el-collapse-item__header {
    padding-left: 20px;
}
.buttonClass {
    margin-top: 170px;
}
.buttonright {
    margin-left: 8px;
}
.buttonleft {
    margin-top: 20px;
}
.search {
    margin: 15px 0;
}
.el-collapse-item__content {
    padding-bottom: 10px;
}
/deep/.el-table__empty-block {
    width: 100% !important;
}
/deep/.el-table__header {
    width: 100% !important;
}
</style>
